<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                :showAddNew="false"
                title="Employee List Import"
            >
                <template #extra-btn>
                    <a
                        download
                        href="/file/import-employee-list.xlsx"
                        class="btn btn-outline-secondary waves-effect waves-float waves-light"
                    >Download Sample</a>
                </template>
            </TitleButton>
            <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
        </div>

        <div class="row p-2">
            <div class="col-12 col-sm-6 col-md-5 col-lg-4">
                <label class="col-form-label">Roles</label>
                <v-select
                    placeholder="Select Roles"
                    v-model="roleId"
                    :options="companyRoles"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div v-show="roleId" class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="uploadCsv" class="btn btn-primary waves-effect waves-float waves-light">
                    Browse
                </button>
            </div>
        </div>

        <div class="p-2">
            <div v-for="(item, index) in csvRow" :key="index">
                <div @click="gotoUpload(item.id)" class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center cursor-pointer">
                    <span class="px-1">id: {{ item.id }} Dataset: {{ item.batch }}</span>
                    <div class="d-flex gap-1 px-1">
                        <span class="cursor-pointer text-danger" @click="deleteRow(item.id)"><i class="fas fa-trash"></i></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import { inject, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import handleInventory from '@/services/modules/inventory';
import handleRole from '@/services/modules/role';
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll';

const { uploadEmployees } = handleHrPayroll();
const { fetchCsvRow, deleteCsvRow } = handleInventory();
const { fetchCompanyDefaultRoles } = handleRole();

const uploader = ref(null);
const csvRow = ref([]);
const companyRoles = ref([]);
const roleId = ref(null);

const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const gotoUpload = (id) => {
    const query = Object.assign({}, route.query);
    query.rowId = id;
    router.push({ name: 'employee-upload-contact', params: route.params, query });
};

const getCsvRow = async () => {
    const query = `?company_id=${route.params.companyId}&type=employee`;
    await fetchCsvRow(query).then((res) => {
        if (!res.status) return;
        csvRow.value = res.data;
    });
};

const deleteRow = async (id) => {
    if (!confirm('Are you sure you want to delete this row?')) return;
    const query = `?company_id=${route.params.companyId}&type=employee`;
    await deleteCsvRow(query, id).then((res) => {
        if (!res.status) return showError(res.message);
        csvRow.value = [];
        getCsvRow();
        showSuccess(res.message);
    });
};

const getRoles = async () => {
    const query = `?company_id=${route.params.companyId}`;
    await fetchCompanyDefaultRoles(query).then((res) => {
        if (!res.status) return;
        companyRoles.value = res.data;
    });
};

const uploadCsv = () => {
    uploader.value.click();
};

const handleFileUpload = async (event) => {
    if (!roleId.value) return showError('Please select role');

    const fd = new FormData();
    fd.append('company_id', route.params.companyId);
    fd.append('sheet', event.target.files[0]);
    fd.append('type', 'employee');
    fd.append('role_id', roleId.value);

    await uploadEmployees(fd).then((res) => {
        if (!res.status) return showError(res.message);
        showSuccess(res.message);
        getCsvRow();
    }).catch((e) => {
        showError('Something went wrong');
    });
};

onMounted(() => {
    getRoles();
    getCsvRow();
});
</script>
